/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../common/common';
import '../../payments/purchase';
import '../../payments/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "PurchaseIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "retryCounter": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PurchaseResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failureReasons": {
                    "type": ".squareup.payments.purchase.PurchaseError",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "autoReverse": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "approvalCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cvvStatus": {
                    "type": ".squareup.payments.common.CvvStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "avsStatus": {
                    "type": ".squareup.payments.common.AvsStatus",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PurchaseIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PurchaseResult) {
  $root.addJSON(jsonData);
}

/**
 * Purchase intent.
 *
 * SOURCE PurchaseIntent @ squareup/esperanto/model/purchase.proto at 15:1
 */
export const PurchaseIntent = $root.lookupType('squareup.esperanto.model.PurchaseIntent');
fixType(PurchaseIntent);
Builder.createAndAttachToType(PurchaseIntent);
/**
 * Purchase result.
 *
 * SOURCE PurchaseResult @ squareup/esperanto/model/purchase.proto at 37:1
 */
export const PurchaseResult = $root.lookupType('squareup.esperanto.model.PurchaseResult');
fixType(PurchaseResult);
Builder.createAndAttachToType(PurchaseResult);